'use strict';

var React = require('react');
var PropTypes = require('prop-types');
var CardBrandImage = require('@piconetworks/card-brand-image');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var PropTypes__default = /*#__PURE__*/_interopDefaultLegacy(PropTypes);
var CardBrandImage__default = /*#__PURE__*/_interopDefaultLegacy(CardBrandImage);

var style = {"paymentBadgeContainer":"Payment-module_paymentBadgeContainer__1Q1wl","cardBrandImage":"Payment-module_cardBrandImage__2pLtO","cardDots":"Payment-module_cardDots__2z3mw","last4":"Payment-module_last4__1TaW9","changePaymentMethodLink":"Payment-module_changePaymentMethodLink__24f7U"};

var PaymentBadge = function PaymentBadge(_ref) {
  var cardType = _ref.cardType,
      last4 = _ref.last4,
      linkColor = _ref.linkColor,
      Link = _ref.Link,
      href = _ref.href,
      as = _ref.as;
  return /*#__PURE__*/React__default['default'].createElement("div", {
    className: style.paymentBadgeContainer
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: style.cardBrandImage
  }, /*#__PURE__*/React__default['default'].createElement(CardBrandImage__default['default'], {
    brand: cardType
  })), /*#__PURE__*/React__default['default'].createElement("span", {
    className: style.cardDots
  }, "\u2022\u2022\u2022\u2022"), /*#__PURE__*/React__default['default'].createElement("span", {
    className: style.last4
  }, last4), /*#__PURE__*/React__default['default'].createElement("div", {
    className: style.changePaymentMethodLink
  }, /*#__PURE__*/React__default['default'].createElement(Link, {
    href: href || '/cards',
    as: as || '/cards'
  }, /*#__PURE__*/React__default['default'].createElement("a", {
    style: {
      color: linkColor
    }
  }, "Change Payment Method"))));
};

PaymentBadge.defaultProps = {
  linkColor: '',
  href: null,
  as: null
};
PaymentBadge.propTypes = {
  href: PropTypes__default['default'].oneOfType([PropTypes__default['default'].string, PropTypes__default['default'].object]),
  as: PropTypes__default['default'].oneOfType([PropTypes__default['default'].string, PropTypes__default['default'].object]),
  cardType: PropTypes__default['default'].string.isRequired,
  last4: PropTypes__default['default'].string.isRequired,
  linkColor: PropTypes__default['default'].string,
  Link: PropTypes__default['default'].element.isRequired
};

module.exports = PaymentBadge;
